var client = ShopifyBuy.buildClient({
  domain: 'designdialog-store.myshopify.com',
  storefrontAccessToken: 'c8d9bdbd45dbb8e3da9a24a70e086ec4', // previously apiKey, now deprecated
});

var ui = ShopifyBuy.UI.init(client);

export default ui
